import { LiveProgramWebcastVariation } from '@/@types/content';
import LiveSliceBlock, { LiveSlideProps } from './LiveSliceBlock';
import { IContent } from '@/@types/cms';

export interface LiveNowSlideProps {
  liveProgramWebcasts: LiveProgramWebcastVariation[];
  heading?: string;
  liveProgramProductCode?: string;
  liveProgramVariationPk?: string;
}

const buildSlide = (item: IContent) => {
  return {
    ...item,
    contentType: ['Block', 'LiveSliceBlock']
  };
};

const LiveNowSlideBlock: React.FC<LiveNowSlideProps> = ({
  liveProgramProductCode,
  liveProgramVariationPk,
  liveProgramWebcasts
}) => {
  const selectedWebcast = liveProgramWebcasts.find(
    x => x.code == liveProgramVariationPk && x.parentProductCode == liveProgramProductCode
  );
  const props: LiveSlideProps = buildSlide({ ...selectedWebcast });

  return <LiveSliceBlock {...props} />;
};

export default LiveNowSlideBlock;
